import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableTagsView.
 * @extends JetView
 */
export default class tableTagsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template for rendering the column
                                        if (devConfig.getPermAction('tagsEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('ID'), // Localized column header
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description', // Column ID
                                    header: _('Descripción'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreationDate', // Column ID
                                    header: _('Fecha de Creación'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit action
                                    $$('editwinTags').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'Tag/GetTags'; // API URL for fetching tags
        var filter = ''; // Filter string for API requests

        // Popup window for editing tags
        var popup = webix.ui({
            view: 'window', // Window view
            id: 'editwinTags', // Window ID
            width: screen.width < 500 ? 350 : 450, // Dynamic width based on screen size
            height: screen.width < 500 ? 570 : 320, // Dynamic height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Etiqueta') }, // Label for editing tag
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close window on click
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form view for editing
                    id: 'editform', // Form ID
                    width: screen.width < 500 ? 350 : 450, // Dynamic width based on screen size
                    height: screen.width < 500 ? 570 : 370, // Dynamic height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelWidth: 90, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position
                        },
                        {
                            view: 'text', // Text input for Name
                            label: _('Nombre'),
                            name: 'Name',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Description
                            label: _('Descripcion'),
                            name: 'Description',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo input for State
                            label: _('Estado'),
                            name: 'State',
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position
                            labelWidth: 90, // Label width
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Close window on click
                                        this.getTopParentView().hide();
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Save action
                                        var values = $$('editform').getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Tag/UpdateTag', // API URL for updating tag
                                                '{"Id":' +
                                                    values.Id +
                                                    ',"State":"' +
                                                    values.State +
                                                    '","Name":"' +
                                                    values.Name +
                                                    '","Description":"' +
                                                    values.Description +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Etiqueta Editada', // Success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Close window
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });

        // Popup window for adding tags
        var popupAdd = webix.ui({
            view: 'window', // Window view
            id: 'AddTags', // Window ID
            width: screen.width < 500 ? 350 : 550, // Dynamic width based on screen size
            height: screen.width < 500 ? 500 : 300, // Dynamic height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Añadir Etiqueta') }, // Label for adding tag
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close window on click
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form view for adding
                    id: 'addform', // Form ID
                    width: screen.width < 500 ? 350 : 550, // Dynamic width based on screen size
                    height: screen.width < 500 ? 500 : 250, // Dynamic height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for Name
                            label: _('Nombre'),
                            name: 'Name',
                            required: true, // Required field
                            labelWidth: 100, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position
                        },
                        {
                            view: 'text', // Text input for Description
                            label: _('Descripción'),
                            name: 'Description',
                            required: true, // Required field
                            labelWidth: 100, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position
                        },
                        {
                            view: 'combo', // Combo input for State
                            label: _('Estado'),
                            name: 'IsActivate',
                            required: true, // Required field
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelWidth: 100, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Close window on click
                                        this.getTopParentView().hide();
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Save action
                                        var values = $$('addform').getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Tag/AddTag', // API URL for adding tag
                                                '{"Name":"' +
                                                    values.Name +
                                                    '", "Status":"' +
                                                    values.IsActivate +
                                                    '", "Description":"' +
                                                    values.Description +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Etiqueta Agregada', // Success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Close window
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });

        // Event listener for adding tags
        this.on(this.app, 'addTags:button', (filter) => {
            popupAdd.show(); // Show add tags window
        });

        // Event listener for filtering tags
        this.on(this.app, 'tags:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date filter
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date filter
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player
            );
        });

        $$('editform').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
